__turbopack_context__.v({
  "container": "ArticleFeaturedTickersList-module-scss-module__TC7l4q__container",
  "fillHeight": "ArticleFeaturedTickersList-module-scss-module__TC7l4q__fillHeight",
  "secondaryTickers": "ArticleFeaturedTickersList-module-scss-module__TC7l4q__secondaryTickers",
});
